export const DRAWER_WIDTH = 900;
export const TABLE_HEIGHT = undefined;